import React, {Component } from 'react';
import {Grid, Row, Col} from 'react-bootstrap';

import App from './App.js'
import AaTabs from './AaTabs.js'
import './GridRight.css'

import NavBar from './navBar/NavBar.js';

import BiochemistryMenu from './Biochemistry/BiochemistryMenu.js';


const description = {

  padding: 10,
  border: 10,
  color: 'white',


}

class GridSystem extends React.Component{

  render(){

    return(

<div>

<NavBar />
<Grid fluid = {true}>
  <Row className="show-grid" >
    <Col xs={2} md={2} style = {{padding: 0}}>
      <BiochemistryMenu />
    </Col>
    <Col xs={7} md={7} style = {{padding: 0}}>
       <AaTabs />
    </Col>
    <Col xs={3} md={3} style = {{backgroundColor: '#9E9E9E', marginTop: 47, padding: 20 }}>

        <div> <p style = {description}>  INSTRUCTIONS: <br/> <p id = "instructions">Write full amino acid name in all lower case letters. <br /> Write 'aspartic acid' instead of aspartate, 'glutamic acid' instead of glutamate. </p> <br /> CATEGORIES SECTION: <br /> <p id = "instructions"> Write answers in all lower case letters. <br /> Answers are either 'polar', 'nonpolar', 'acidic', or 'basic' </p> </p> </div>

    </Col>
  </Row>

</Grid>

</div>



);

}
}

export default GridSystem;



// WEBPACK FOOTER //
// ./src/Grid.js